module.exports = __webpack_public_path__ + "img/team-delivery.b58afd9e.svg";